import { Action } from '../../definitions/types';
import * as Actions from '../actions/actions-consts';

import {
  PACKAGE_TYPE_FREE,
  PACKAGE_TYPE_PRO,
  PACKAGE_TYPE_BUSINESS,
  PACKAGE_TYPE_SHOP,
  PACKAGE_TYPE_PLATIN,
} from '../../modules/constants';
import { PackageDescription } from '../../modules/getPackages';
import { Map } from '../../definitions/types';

export type PackageType =
  | 'free'
  | 'pro'
  | 'business'
  | 'shop'
  | 'platin'
  | 'seo';
export type ValidCheckoutPackageType = 'pro' | 'business';
export type ValidCheckoutBundleType = 'JimdoShop' | 'JimdoPlatin' | 'JimdoSeo';
export const PACKAGE_TYPES = [
  PACKAGE_TYPE_FREE,
  PACKAGE_TYPE_PRO,
  PACKAGE_TYPE_BUSINESS,
  PACKAGE_TYPE_SHOP,
  PACKAGE_TYPE_PLATIN,
];

export interface PricingState {
  selectedPackage?: PackageType;
  skipPricingView?: boolean;
  rankingCoachAvailable?: boolean;
  packages: Map<PackageDescription>;
}

export const shouldSkipPricingView = (state: PricingState): boolean => {
  if (!state) {
    return false;
  }

  const { skipPricingView, selectedPackage } = state;
  if (!selectedPackage) {
    // If no package has been selected we ignore the skip value,
    // so the user must select a package.
    return false;
  }

  return Boolean(skipPricingView);
};

export const paidPackageIsSelected = (state: PricingState): boolean => {
  if (!state) {
    return false;
  }

  return (
    state.selectedPackage === 'pro' || state.selectedPackage === 'business'
  );
};

export const getSelectedPackage = (state: PricingState): PackageType => {
  if (!state) {
    return null;
  }

  return state.selectedPackage;
};

const setPackage = (
  state: PricingState,
  packageType: PackageType
): PricingState => {
  if (state && state.selectedPackage === packageType) {
    return state;
  }

  // Since the given package type can be set via url query param we have to check
  // the given value explicitly and cannot rely on the parameter type (PackageType).
  if (PACKAGE_TYPES.indexOf(packageType) < 0) {
    return state;
  }

  return Object.assign({}, state, {
    selectedPackage: packageType,
  });
};

const setSkipPricingView = (
  state: PricingState,
  value: boolean
): PricingState => {
  if (state.skipPricingView === value) {
    return state;
  }

  return Object.assign({}, state, {
    skipPricingView: value,
  });
};

const initialState: PricingState = {
  selectedPackage: null,
  skipPricingView: null,
  packages: undefined,
  rankingCoachAvailable: false,
};

export default function pricing(
  state: PricingState = initialState,
  action: Action<any> // tslint:disable-line no-any
): PricingState {
  switch (action.type) {
    case Actions.SET_PACKAGE:
      return setPackage(state, action.payload);
    case Actions.SET_PACKAGES:
      return Object.assign({}, state, {
        packages: action.payload,
      });
    case Actions.SET_RANKING_COACH_AVAILABLE:
      return Object.assign({}, state, {
        rankingCoachAvailable: action.payload,
      });
    case Actions.SKIP_PRICING_VIEW:
      return setSkipPricingView(state, true);
    default:
      return state;
  }
}
